import { render } from "./VouchersBills.vue?vue&type=template&id=21848f64&scoped=true"
import script from "./VouchersBills.vue?vue&type=script&lang=js"
export * from "./VouchersBills.vue?vue&type=script&lang=js"

import "./VouchersBills.vue?vue&type=style&index=0&id=21848f64&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21848f64"]])

export default __exports__